import React from "react";

import { Button, Grid, Typography } from "@mui/material";

export const Err404 = () => (
    <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: "100vh" }}
    >
        <Grid container item xs={3} sx={{ width: "35rem" }} justifyContent="center">
            <Typography variant="h4">404</Typography>
            <Typography variant="body1" sx={{ margin: "2rem" }}>
                The page you are looking for might have been removed, had its url changed or is
                temporarily unavailable.
            </Typography>
            <Button variant="outlined" color="primary" href="/">
                Home
            </Button>
        </Grid>
    </Grid>
);
